query PurchaseOrderAvailableDocumentTypes($purchaseOrderTypeId: Int!) {
  purchaseOrderAvailableDocumentTypes(
    purchaseOrderTypeId: $purchaseOrderTypeId
    isDocumentUpload: false
  ) {
    nodes {
      id
      documentType
      isAccountingDocument
      _isAppliableDocumentType
    }
  }
}
